import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogClose,
  DialogTitle,
  DialogDescription,
  DialogOverlay,
  DialogPortal,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { DeleteIcon } from "lucide-react";
import { useProjects } from "@/context/ProjectContext";
import { GetProjectResponseDto } from "@/dto/get-project-response.dto";
import { UnifiedProjectInvitation } from "@/services/projectService";

interface DeleteProjectInviteDialogProps {
  project: GetProjectResponseDto;
  invitation: UnifiedProjectInvitation;
}

export function DeleteProjectInviteDialog({
  project,
  invitation,
}: DeleteProjectInviteDialogProps) {
  const { deleteProjectInvite, deletingInvite } = useProjects();

  const handleConfirmDelete = () => {
    deleteProjectInvite(invitation._id, project._id);
  };

  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="destructive"
          size="sm"
          className="w-full flex items-center justify-between"
        >
          Remove <DeleteIcon className="h-4 w-4" />
        </Button>
      </DialogTrigger>

      <DialogPortal>
        <DialogOverlay className="bg-black/45" />
        <DialogContent>
          <DialogTitle className="text-lg font-semibold">
            Confirm Deletion
          </DialogTitle>
          <DialogDescription>
            Are you sure you want to delete the invitation to{" "}
            <strong>{invitation.email}</strong> from the project{" "}
            <strong>{project.name}</strong>? This action cannot be undone.
          </DialogDescription>
          <div
            style={{
              display: "flex",
              gap: 10,
              justifyContent: "flex-end",
            }}
          >
            <DialogClose asChild>
              <Button variant="outline">Cancel</Button>
            </DialogClose>
            <DialogClose asChild>
              <Button
                variant="destructive"
                onClick={handleConfirmDelete}
                disabled={deletingInvite}
              >
                {deletingInvite ? "Deleting..." : "Confirm"}
              </Button>
            </DialogClose>
          </div>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
}
